import { onMount } from 'svelte';
import pb from './pocketbase';

let user;

// Validate token and fetch user data
export async function validateTokenAndFetchUserData() {
    const token = localStorage.getItem("pb_token");
    const user = localStorage.getItem("pb_user");

    if (token && user) {
        try {
            // Check if token is valid
            if (pb.authStore.isValid) {
                console.log(`Login successful! Welcome, ${JSON.parse(user).email}`);
                return user;
            } else {
                // Token is invalid or expired
                console.warn("Token is invalid or expired");
                return null;
            }
        } catch (error) {
            console.error("Error during authentication or fetching data:", error);
            return null;
        }
    } else {
        console.warn("No token found in local storage");
        return null;
    }
}
